<div class="header-container">
    <span class="title">{{ title() }}</span>
    @if (tooltipText() && tooltipIcon()) {
        <span class="icon" [innerHTML]="tooltipIcon()" libTooltip [tooltip]="tooltipText()"></span>
    }
</div>
